import React, { useState } from "react";
import { FieldType } from "../../../services/helpers/types";
import { fieldRenderer } from "./helper";
import classNames from "classnames";
import Button from "../../atoms/Button/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TextField from "../../atoms/TextField/TextField";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { MAX_POSITION } from "../../../services/helpers/constants";
import { useTranslation } from "react-i18next";

interface FieldProps {
  field: FieldType;
  value?: string;
  noteOptionValue?: string;
  isVisible?: boolean;
  className?: string;
  onFieldChange: (field: FieldType, value?: string) => void;
  onNoteOptionChange: (field: FieldType, value?: string) => void;
  onFieldVisibilityChange: (field: FieldType, value: boolean) => void;
}

const Field = (props: FieldProps) => {
  const {
    field,
    value,
    className,
    noteOptionValue,
    isVisible,
    onFieldChange,
    onNoteOptionChange,
    onFieldVisibilityChange,
  } = props;

  const { t } = useTranslation();

  const [isNoteOptionOpen, setIsNoteOptionOpen] = useState(
    noteOptionValue !== undefined && noteOptionValue !== ""
  );
  const [isFieldVisible, setIsFieldVisible] = useState(isVisible ?? true);

  const handleFieldChange = (value?: string) => {
    onFieldChange(field, value);
  };
  const handleNoteOptionExpand = () => {
    setIsNoteOptionOpen(!isNoteOptionOpen);
  };
  const handleNoteOptionChange = (value?: string) => {
    onNoteOptionChange(field, value);
  };

  const handleFieldVisibility = () => {
    onFieldVisibilityChange(field, !isFieldVisible);
    setIsFieldVisible(!isFieldVisible);
  };

  const currentClassName = classNames("dui-field", className);
  return (
    <div className="dui-field-wrapper">
      <div className={currentClassName}>
        <div className="dui-field-left">
          {field.position !== MAX_POSITION && (
            <Button
              icon={isFieldVisible ? <Visibility /> : <VisibilityOff />}
              type="text"
              className={classNames("dui-field-icon", {
                "dui-field-icon-hidden": !isFieldVisible,
              })}
              onClick={handleFieldVisibility}
            />
          )}
          <div className="dui-field-label">{field.name}</div>
        </div>

        <div className="dui-field-right">
          <div className="dui-field-input">
            {fieldRenderer(field, handleFieldChange, value)}
          </div>
          {field.noteOption ? (
            <Button
              icon={
                isNoteOptionOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              onClick={handleNoteOptionExpand}
              type="text"
              className="dui-field-expand-button"
            />
          ) : (
            <div className="dui-field-expand-spacer" />
          )}
        </div>
      </div>
      {isNoteOptionOpen ? (
        <div className="dui-field-note-option">
          <TextField
            value={noteOptionValue}
            onChange={handleNoteOptionChange}
            placeholder={t("addComment")}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Field;
